import { subscribe } from "@shared/utils.events";
import { useSegment } from "./useSegment";

type Props = {
  target: string;
  target2?: string;
  details?: string;
  location?: string;
  details2?: string;
  details3?: string;
  locationDetails?: string;
  contentUrl?: string;
};

export const PAGE_ELEMENT_VIEWED_EVENT_KEY = "page element viewed";
export const PAGE_ELEMENT_CLICKED_EVENT_KEY = "page element clicked";

export const usePageElementEvents = (): (() => void) => {
  const { track } = useSegment();

  return () => {
    subscribe(PAGE_ELEMENT_VIEWED_EVENT_KEY, (payload) => {
      const { target, target2, details, location, locationDetails } =
        payload as Props;
      track({
        event: "Page Element Viewed",
        properties: {
          module_content: target,
          ...(target2 && { module_content2: target2 }),
          ...(details && { module_content_details: details }),
          ...(location && { location_type: location }),
          ...(locationDetails && { location_type_details: locationDetails })
        }
      });
    });
    subscribe(PAGE_ELEMENT_CLICKED_EVENT_KEY, (payload) => {
      const {
        target,
        target2,
        details,
        location,
        details2,
        details3,
        locationDetails,
        contentUrl
      } = payload as Props;
      track({
        event: "Page Element Clicked",
        properties: {
          module_content: target,
          ...(target2 && { module_content2: target2 }),
          ...(details && { module_content_details: details }),
          ...(location && { location_type: location }),
          ...(details2 && { module_content_details2: details2 }),
          ...(details3 && { module_content_details3: details3 }),
          ...(locationDetails && { location_type_details: locationDetails }),
          ...(contentUrl && { module_content_url: contentUrl })
        }
      });
    });
  };
};
